/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PrueflaufBerechtigung { 
    ist_ok?: boolean;
    ist_pruefer?: boolean;
    pruefer_rollen_ids?: Array<string>;
    pruefplan_id?: string;
    reason?: string;
    rolle_id?: string;
    veranstaltung_id?: string;
    mandant_id?: string;
}

